// @greenlight-spec: 28-it-dashboard-ui.md
// @greenlight-spec: 09-data-brokering.md#scope-model
// Public docs-site pages the dashboard links to. Every URL keeps its trailing
// slash: the docs site serves directory indexes, and the slash-less form redirects.

const DOCS_BASE = 'https://greenlightbyshift.com/docs';

export const DOCS_LINKS = {
  dns: `${DOCS_BASE}/admins/dns/`,
  idpInstallEntra: `${DOCS_BASE}/admins/install/entra/`,
  idpInstallGoogle: `${DOCS_BASE}/admins/install/google/`,
  idpInstallOkta: `${DOCS_BASE}/admins/install/okta/`,
  idpInstallGenericOidc: `${DOCS_BASE}/admins/install/generic-oidc/`,
  dataAccessTerms: `${DOCS_BASE}/security/data-access-terms/`,
  dataBrokering: `${DOCS_BASE}/concepts/data-brokering/`,
  uninstall: `${DOCS_BASE}/admins/uninstall/`,
  notificationEmailAzure: `${DOCS_BASE}/admins/install-azure/#notification-email`,
  notificationEmailGcp: `${DOCS_BASE}/admins/install-gcp/#notification-email`,
  notificationEmailAws: `${DOCS_BASE}/admins/install-aws/#notification-email`,
  buildWithYourAgent: `${DOCS_BASE}/builders/build-with-your-agent/`,
} as const;
